import {
  Component,
  OnInit,
  ChangeDetectorRef,
} from "@angular/core";
import {
  FormBuilder,
} from "@angular/forms";
import {
  DataService,
  QueryResult,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import { concat, Observable, of, Subject } from "rxjs";
import { ProductSelectorComponent } from "../../product-selector/product-selector.component";
import {
  GetCustomersForCouponDocument,
  GetCustomersForCouponQuery,
  GetCustomersForCouponQueryVariables,
} from "src/generated-gql/graphql";
import { BehaviorSubject, tap, map } from "rxjs";
import { SingleCurrencyCodeSelectorComponent } from "../single-currency-code-selector/single-currency-code-selector.component";
import { CustomItemsPerPageControlsComponent } from "./items-per-page-controls/items-per-page-controls.component";
import { CustomPaginationControlsComponent } from "./pagination-controls/pagination-controls.component";

type CustomerForCoupon =
  GetCustomersForCouponQuery["customersForCoupon"]["items"][0];

@Component({
  selector: "customer-filter-table",
  imports: [
    SharedModule,
    ProductSelectorComponent,
    SingleCurrencyCodeSelectorComponent,
    CustomPaginationControlsComponent,
    CustomItemsPerPageControlsComponent,
  ],
  standalone: true,
  templateUrl: "./customer-filter-table.component.html",
  styleUrls: ["./customer-filter-table.component.scss"],
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerFilterTableComponent implements OnInit {
  customers$: Observable<
    GetCustomersForCouponQuery["customersForCoupon"]["items"]
  >;
  private listQuery: QueryResult<
    GetCustomersForCouponQuery,
    GetCustomersForCouponQueryVariables
  >;
  errorMessage = "";
  private filterSource = new BehaviorSubject<boolean>(false);
  filter = this.filterSource.asObservable();
  productList: any[] = [];

  selected: CustomerForCoupon[] = [];

  displays: CustomerForCoupon[] = [];

  tempProductList: any[] = [];
  paginationConfig = {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 1,
  };
  customerList: any[] = [];
  constructor(
    protected dataService: DataService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    // super();
    // super.configure({
    //   document: GetCustomersForCouponDocument,
    //   getItems: (result) => {
    //     console.log(result);
    //     return result.customersForCoupon;
    //   },
    //   setVariables: (skip, take) => ({
    //     options: {
    //       skip,
    //       take,
    //       noOrderInDays: this.filterForm.value.noOrderInDays
    //         ? this.filterForm.value.noOrderInDays
    //         : undefined,
    //       productIds:
    //         this.productList.length > 0
    //           ? this.productList.map((p) => p.id)
    //           : undefined,
    //       lastLoginDays: this.filterForm.value.lastLoginDays
    //         ? this.filterForm.value.lastLoginDays
    //         : undefined,
    //       totalPurchaseAmount: this.filterForm.value.currencyCode
    //         ? {
    //             currencyCode: this.filterForm.value.currencyCode as any,
    //             total: this.filterForm.value.totalPurchaseAmount!,
    //           }
    //         : undefined,
    //       // totalPurchaseAmount: this.filterForm.value.totalPurchaseAmount
    //       //   ? this.filterForm.value.totalPurchaseAmount
    //       //   : undefined,
    //     },
    //   }),
    //   refreshListOnChanges: [this.filter],
    // });
  }
  ngOnInit(): void {
    this.listQuery = this.getCustomerList({
      take: this.paginationConfig.itemsPerPage,
      skip: 0,
    });
    this.customers$ = this.listQuery.stream$.pipe(
      tap((result) => {
        this.paginationConfig.totalItems = result.customersForCoupon.totalItems;
      }),
      map((result) => {
        return result.customersForCoupon.items;
      })
    );

    this.customers$.subscribe((res) => {
      if (res) {
        this.displays = res;
      }
    });
  }

  getCustomerList(options: GetCustomersForCouponQueryVariables["options"]) {
    return this.dataService.query(GetCustomersForCouponDocument, {
      options: {
        skip: 0,
        take: 10,
      },
    });
  }

  private fetchPage(currentPage: number, itemsPerPage: number) {
    const take = +itemsPerPage;
    const skip = (currentPage - 1) * +itemsPerPage;

   
    this.listQuery.ref.refetch({
      options: {
        skip,
        take,
        noOrderInDays: this.filterForm.value.noOrderInDays
          ? this.filterForm.value.noOrderInDays
          : undefined,
        productIds:
          this.productList.length > 0
            ? this.productList.map((p) => p.id)
            : undefined,
        lastLoginDays: this.filterForm.value.lastLoginDays
          ? this.filterForm.value.lastLoginDays
          : undefined,
        totalPurchaseAmount: this.filterForm.value.currencyCode
          ? {
              currencyCode: this.filterForm.value.currencyCode as any,
              total: this.filterForm.value.totalPurchaseAmount!,
            }
          : undefined,
      },
    });

    this.cdr.markForCheck();
  }
  tempForm = this.formBuilder.group({
    lastLoginDays: [null],
    noOrderInDays: [null],
    totalPurchaseAmount: [null],
    currencyCode: [null],
  });

  filterForm = this.formBuilder.group({
    lastLoginDays: [null],
    noOrderInDays: [null],
    totalPurchaseAmount: [null],
    currencyCode: [null],
  });

  onSelectProduct(event: any) {
    if (event) {
      if (!this.tempProductList.find((p) => p.id === event.id)) {
        this.tempProductList.push(event);
      }
    }
  }

  applyFilter() {
    const filterData = this.tempForm.value;

    if (filterData.totalPurchaseAmount && !filterData.currencyCode) {
      this.errorMessage =
        "To filter customer by total purchase amount, currency code must be selected";
      return;
    }

    this.filterForm.patchValue({
      noOrderInDays: filterData.noOrderInDays ?? null,
      lastLoginDays: filterData.lastLoginDays ?? null,
      totalPurchaseAmount: filterData.totalPurchaseAmount ?? null,
      currencyCode: filterData.currencyCode ?? null,
    });

    this.productList = [...this.tempProductList];
    this.errorMessage = "";
    this.filterSource.next(true);

    this.fetchPage(
      this.paginationConfig.currentPage,
      this.paginationConfig.itemsPerPage
    );
  }

  clearFilter() {
    this.tempForm.patchValue({
      noOrderInDays: null,
      lastLoginDays: null,
      totalPurchaseAmount: null,
      currencyCode: null,
    });

    this.tempProductList = [];

    this.filterForm.patchValue({
      noOrderInDays: null,
      lastLoginDays: null,
      totalPurchaseAmount: null,
      currencyCode: null,
    });

    this.productList = [];
    this.errorMessage = "";

    this.fetchPage(
      this.paginationConfig.currentPage,
      this.paginationConfig.itemsPerPage
    );

    //this.filterSource.next(true);
  }

  pageChange(page: number) {
    this.paginationConfig.currentPage = page;

    console.log(this.paginationConfig);

    this.fetchPage(
      this.paginationConfig.currentPage,
      this.paginationConfig.itemsPerPage
    );
  }

  itemsPerPageChange(itemsPerPage: number) {
    this.paginationConfig.itemsPerPage = itemsPerPage;
    this.fetchPage(
      this.paginationConfig.currentPage,
      this.paginationConfig.itemsPerPage
    );
  }

  areAllCurrentItemsSelected() {
    return this.displays.length === this.selected.length;
  }

  isItemSelected(id: string) {
    return this.selected.find((s) => s.id === id);
  }

  selectItem(item: CustomerForCoupon) {
    this.selected.push(item);
  }

  onToggleAllClick(event: any) {
    if (event.target.value) {
      this.selected = [];

      for (const d of this.displays) {
        this.selected.push(d);
      }
    } else {
      this.selected = [];
    }
  }
}
